import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import isArray from 'lodash/fp/isArray';
import map from 'lodash/fp/map';
import toPairs from 'lodash/fp/toPairs';
const Note = (props) => {
    const { note, version } = props;
    const { date, content } = note;
    return (_jsxs("div", Object.assign({ className: 'panel panel-default' }, { children: [_jsx("div", Object.assign({ className: 'panel-heading' }, { children: _jsxs("div", Object.assign({ className: 'display-flex justify-content-between' }, { children: [_jsx("span", Object.assign({ className: 'text-size-16 text-medium' }, { children: `${version}` })), _jsx("span", Object.assign({ className: 'text-thin' }, { children: date }))] })) })), _jsx("div", Object.assign({ className: 'panel-body white-space-pre-line' }, { children: isArray(content) ? (_jsx("ul", Object.assign({ className: 'margin-bottom-0 margin-left-5 padding-left-25' }, { children: map((item) => (_jsx("li", { children: item }, `${version}-note-${Math.random()}`)), content) }))) : (_jsx("div", { children: content })) }))] }), `${version}-note`));
};
const ReleaseNotes = (props) => {
    const { releaseNotes } = props, remainingProps = __rest(props, ["releaseNotes"]);
    return (_jsx("div", Object.assign({}, remainingProps, { children: map(([key, note]) => (_jsx(Note, { note: note, version: key }, key)), toPairs(releaseNotes)) })));
};
export default ReleaseNotes;
